// components
import CommonForm from "../Common/CommonForm";
import {splitToList} from "../../utils/misc";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";


class WebinarCreateModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'primary',
            ready: true,
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields()
        return {
            modalLabel: 'Добавление вебинара',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async retrieveFields(){
        const url = `webinar/create_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        return response.data
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        if ('tags' in formDataObj) {
            formDataObj.tags = splitToList(formDataObj.tags, ',')
        }
        if ('speakers' in formDataObj) {
            formDataObj.speakers = splitToList(formDataObj.speakers, ',')
        }
        const url = `webinar/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (typeof this.props.callBack == 'function') {
                await this.props.callBack();
            }
            this.setModalOpenFalse();
        }
        return response
    }
}

export default WebinarCreateModal
